// @flow

import { startRequest, finishRequest } from "@store/utils";

import type { State } from "@store/reducers";

export const startLoading = (state: State) => () => ({
  ...state,
  hierarchy: {
    ...startRequest(state.hierarchy),
  },
});

export const finishLoading = (state: State) => () => ({
  ...state,
  hierarchy: {
    ...finishRequest(state.hierarchy),
  },
});

export const onToggleAddEditShiftPatternModal = (state: State) => ({
  payload,
}: $Exact<{
  action: string,
  payload: $Exact<{
    visible: boolean,
    assignedShiftPattern?: *,
  }>,
}>) => {
  return {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      modals: {
        ...state.hierarchy.modals,
        addEditShiftPatternModal: {
          ...state.hierarchy.modals.addEditShiftPatternModal,
          visible: payload.visible || !state.hierarchy.modals.addEditShiftPatternModal.visible,
          assignedShiftPattern: payload.assignedShiftPattern,
        },
      },
    },
  };
};

export const onToggleAddEditContactModal = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      modals: {
        ...state.hierarchy.modals,
        addEditContactModal: {
          ...state.hierarchy.modals.addEditContactModal,
          visible: payload.visible,
          notificationContact: payload.notificationContact || null,
        },
      },
    },
  };
};

export const onSetNotificationContact = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      modals: {
        ...state.hierarchy.modals,
        addEditContactModal: {
          ...state.hierarchy.modals.addEditContactModal,
          notificationContact: payload,
        },
      },
    },
  };
};

export const onGetHierarchyShiftPatternSchemaSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      hierarchyShiftPatternSchema: payload,
    },
  };
};

export const onGetActiveHierarchyTreeSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      activeHierarchyTree: payload,
    },
  };
};

export const onDiscardDraftSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      draftHierarchyTree: payload,
    },
  };
};

export const onSelectOrganizationalUnit = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...state.hierarchy,
      selectedOrganisationalUnit: payload.branch,
    },
  };
};

export const onGetDraftHierarchyTreeSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      draftHierarchyTree: payload,
    },
  };
};

export const onGetDraftHierarchyTreeChangelogSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      changelog: payload,
    },
  };
};

export const onGetNotificationContactsSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      notificationContacts: payload,
    },
  };
};

export const onGetHierarchyNotificationsSummarySuccess = (state: State) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      notificationSummary: payload,
    },
  };
};

export const onGetHierarchyShiftPatternsSuccess = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    hierarchy: {
      ...finishRequest(state.hierarchy),
      shiftPatterns: payload,
    },
  };
};

export const onError = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    hierarchy: {
      ...finishRequest(state.hierarchy),
    },
  };
};

export const onToggleHierarchySidebar = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      isSidebarExpanded: payload,
    },
  };
};

export const onToggleEditDraftHierarchyModal = (state: State) => ({ payload }: Object) => {
  return {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      modals: {
        ...state.hierarchy.modals,
        editDraft: {
          visible: payload,
        },
      },
    },
  };
};
